import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '~environment';
import { Metrics } from '../model';
import { ApiBase } from "~core/services/base-api.service";

@Injectable()
export class IdapService extends ApiBase {

  getMetricsData(): Observable<Metrics> {
    return this.get(`${environment.baseUrl}/properties/idapdatagrid`)
  }

  getCopyrightText() {
    return this.get(`/copyright`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/idap.service.ts